import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminLiteralPage } from 'app/components/admin/admin-literal/admin-literal.page';
import { AdminLockerPage } from 'app/components/admin/admin-locker/admin-locker.page';


import { AdminMainComponent } from './admin-main.component';
import { AdminReservationPage } from '../../components/admin/admin-reservation/admin-reservation.page';
import { AdminUserPage } from '../../components/admin/admin-user/admin-user.page';
import { AdminConfigPage } from '../../components/admin/admin-config/admin-config.page';
import { AdminSettingFiscalPage } from 'app/components/admin/admin-setting-fiscal/admin-setting-fiscal.page';
import { AdminProductPage } from 'app/components/admin/admin-product/admin-product.page';
import { AdminDiscountPage } from 'app/components/admin/admin-discount/admin-discount.page';
import { AdminSchedulePage } from 'app/components/admin/admin-schedule/admin-schedule.page';
import { AdminSenderPage } from 'app/components/admin/admin-sender/admin-sender.page';
import { AdminPaymentPage } from 'app/components/admin/admin-payment/admin-payment.page';
import { PaymentProviderPage } from 'app/components/admin/admin-payment-provider/admin-payment-provider-page';
import { AdminCategoryPage } from 'app/components/admin/admin-category/admin-category.page';
import { AdminReportInvoicePage } from 'app/components/admin/admin-report-invoice/admin-report-invoice.page';
import { HasRoleGuard } from '../../auth/guards/has-roles/has-role.guard';
import { AdminCustomerPage } from 'app/components/admin/admin-customer/admin-customer.page';
import { AdminLoggerPage } from 'app/components/admin/admin-logger/admin-logger.page';
import { AdminMaintenancePage } from 'app/components/admin/admin-maintenance/admin-maintenance.page';
import { AdminInvoicePage } from 'app/components/admin/admin-invoice/admin-invoice.page';
import { WorkerManagerPage } from 'app/components/admin/admin-worker-manager/admin-worker-manager-page';
import { AdminPoolPage } from '../../components/admin/admin-pool/admin-pool.page';
import { AdminCompanyPage } from 'app/components/admin/admin-company/admin-company.page';
import { AdminDashboardPage } from 'app/components/admin/admin-dashboard/admin-dashboard.page';
import { PendingEventPage } from 'app/components/admin/admin-pending-event/admin-pending-event-page';
import { KioskSyncPage } from 'app/components/admin/admin-kiosk-sync/admin-kiosk-sync-page';
import { AdminEmptyComponent } from './admin-empty.component';
import { AdminKioskPage } from 'app/components/admin/admin-kiosk/admin-kiosk.page';

const routes: Routes = [
  {
    path: '', component: AdminMainComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: AdminEmptyComponent,
        data: { allowWithoutLocation: true }
      },
      {
        path: 'dashboard',
        component: AdminDashboardPage,
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard],
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_MANAGER'] }
      },
      {
        path: 'company',
        component: AdminCompanyPage,
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard],
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_SUPERMANAGER'], allowWithoutLocation: true }
      },
      {
        path: 'category',
        component: AdminCategoryPage,
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard],
        data: { allowedRoles: ['ROLE_ADMIN'] }
      },
      { 
        path: 'product', 
        component: AdminProductPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN'] } 
      },
      { 
        path: 'locker', 
        component: AdminLockerPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_MANAGER'] } 
      },
      { 
        path: 'literal', 
        component: AdminLiteralPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN'], allowWithoutLocation: true } 
      },
      { 
        path: 'reservation', 
        component: AdminReservationPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_MANAGER'] } 
      },
      { 
        path: 'discount', 
        component: AdminDiscountPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_SUPERMANAGER'] } 
      },
      { 
        path: 'maintenance', 
        component: AdminMaintenancePage, 
        canActivate: [HasRoleGuard], 
        canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_MANAGER'] } 
      },
      { 
        path: 'config', 
        component: AdminConfigPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_SUPERMANAGER'] } 
      },
      {
        path: 'setting-fiscal',
        component: AdminSettingFiscalPage,
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard],
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_SUPERMANAGER'] }
      },
      { 
        path: 'user', 
        component: AdminUserPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_MANAGER'], allowWithoutLocation: true } 
      },
      { 
        path: 'customer', 
        component: AdminCustomerPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN'] } 
      },
      { 
        path: 'schedule', 
        component: AdminSchedulePage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN'] } 
      },
      { 
        path: 'sender', 
        component: AdminSenderPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN'] } 
      },
      { 
        path: 'payments', 
        component: AdminPaymentPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_SUPERMANAGER'] } 
      },
      { 
        path: 'invoice', 
        component: AdminInvoicePage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_SUPERMANAGER'] } 
      },
      { 
        path: 'report-invoice', 
        component: AdminReportInvoicePage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_MANAGER'] } 
      },
      { 
        path: 'payment-provider', 
        component: PaymentProviderPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN'] } 
      },
      { 
        path: 'worker-manager', 
        component: WorkerManagerPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN'] } 
      },
      { 
        path: 'loggers', 
        component: AdminLoggerPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN'] } 
      },
      { 
        path: 'pool', 
        component: AdminPoolPage, 
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard], 
        data: { allowedRoles: ['ROLE_ADMIN', 'ROLE_SUPERMANAGER'] } 
      },
      {
        path: 'pending-event',
        component: PendingEventPage,
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard],
        data: { allowedRoles: ['ROLE_ADMIN'] }
      },
      {
        path: 'kiosk-sync',
        component: KioskSyncPage,
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard],
        data: { allowedRoles: ['ROLE_ADMIN'] }
      },
      {
        path: 'admin-kiosk',
        component: AdminKioskPage,
        canActivate: [HasRoleGuard], canLoad: [HasRoleGuard],
        data: { allowedRoles: ['ROLE_ADMIN'] }
      },
      { 
        path: '**', 
        redirectTo: 'dashboard', 
        pathMatch: 'full' 
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminMainPageRoutingModule { }
